// Distance calculation utility
export function distance(position1, position2) {
  // Check if positions are valid objects before accessing properties
  if (!position1 || !position2) {
    return null;
  }
  
  var lat1 = parseFloat(position1.Lat || position1.lat);
  var lat2 = parseFloat(position2.Lat || position2.lat);
  var lon1 = parseFloat(position1.Lng || position1.lng);
  var lon2 = parseFloat(position2.Lng || position2.lng);

  // Guard: If any coordinate is missing or not a finite number, return null
  if (!Number.isFinite(lat1) || !Number.isFinite(lat2) || !Number.isFinite(lon1) || !Number.isFinite(lon2)) {
    return null;
  }

  var radlat1 = Math.PI * lat1/180;
  var radlat2 = Math.PI * lat2/180;
  var theta = lon1-lon2;
  var radtheta = Math.PI * theta/180;
  var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
  if (dist > 1) {
    dist = 1;
  }
  dist = Math.acos(dist);
  dist = dist * 180/Math.PI;
  dist = dist * 60 * 1.1515;
  return dist;
}
